export const tableConfig = {
    name: 'contractRegistration',
    selection: false,
    index: false,
    height: '375px',
    columns: [
        {
            label: '单据编号',
            type: 'slot',
            prop: 'contractCode'
        },
        {
            label: '客户名称',
            prop: 'customerName'
        },
        {
            label: '分公司',
            prop: 'companyName',
            width: 100
        },
        {
            label: '登记终止时间',
            prop: 'earlyTerminationTime'
        },
        {
            label: '待办跟进人',
            prop: 'handlerName'
        }
    ]
};
